import { render, staticRenderFns } from "./AlertSellInSingleCopy.vue?vue&type=template&id=5566acea"
import script from "./AlertSellInSingleCopy.vue?vue&type=script&lang=js"
export * from "./AlertSellInSingleCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports